import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteNotificationService} from "../../services/notifications/deleteNotifications";

const useDeleteNotification = () => {
  const query = useQueryClient();
  const {isPending, isSuccess, mutate, error, isError} = useMutation({
    mutationKey: ["deleteNotification"],
    mutationFn: deleteNotificationService,
    onSuccess: _data => {
      query.invalidateQueries({queryKey: ["listNotifications"]});
    },
  });

  return {
    deleteNotification: mutate,
    isSuccess,
    isError,
    error,
    isPending,
  };
};

export default useDeleteNotification;
